import { render, staticRenderFns } from "./BrandingStep.vue?vue&type=template&id=43d6c34c&scoped=true"
import script from "./BrandingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandingStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BrandingStep.vue?vue&type=style&index=0&id=43d6c34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6c34c",
  null
  
)

export default component.exports